import * as React from "react"
import { ThemeProvider, CssBaseline } from "@material-ui/core";
import theme from "./theme"

export default ({children})=> (<ThemeProvider theme={theme}>
    <CssBaseline />
    {children}
</ThemeProvider>)